import React, { useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import useDesktop from '@hooksV2/useDesktop';
import PdfViewerBase from '@vb/components/build/components/molecules/PdfViewerBase/PdfViewerBase';
import CloseBold from '../../assets/icons/RemoveCircleBold';
import styles from './style';

import './styles.scss';
import ErrorBoundary from '../ErrorBoundary';
import { toLowerCase } from '../../utils/strings';
import { logLevelWarning } from '../../utils/loggers';
import ShowErrorMessage from '../ShowErrorMessage';
import Plus from '../../assets/icons/AddCircleBold';
import Minus from '../../assets/icons/SubtractCircleBold';

const videoFileTypes = [
  'mp4',
  'webm',
  'ogg',
  'avi',
  'flv',
  'mkv',
  'mov',
  'wmv',
];

const FileViewer = ({
  classes,
  fileType,
  filePath,
  className,
  isConvertedFile,
}) => {
  const zoomLevels = [
    0.25, 0.33, 0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2, 2.5, 3,
    4, 5,
  ];
  const isDesktop = useDesktop();

  const [zoomLevelIndex, setZoomLevelIndex] = useState(isDesktop ? 7 : 3);
  const containerRef = useRef(null);
  const history = useHistory();
  const { boligmappaNumber } = useParams();

  const onZoomIn = () => {
    if (zoomLevelIndex < zoomLevels.length - 1) {
      setZoomLevelIndex(zoomLevelIndex + 1);
    }
  };
  const onZoomOut = () => {
    if (zoomLevelIndex > 0) {
      setZoomLevelIndex(zoomLevelIndex - 1);
    }
  };

  const onDocumentClose = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      history.push(`/dashboard/${boligmappaNumber}/documents`);
    }
  };

  if (videoFileTypes.includes(toLowerCase(fileType))) {
    return (
      <>
        <div className={classes.videoWrapper}>
          <video className={classes.videoPlayer} controls>
            <track default kind="captions" />
            <source src={filePath} type="video/mp4" />
          </video>
        </div>
        <div
          className={clsx(
            className,
            classes.previewZoomButtons,
            !isDesktop && 'mobile'
          )}
        >
          <button
            type="button"
            aria-label="zoom out"
            onClick={() => onDocumentClose()}
          >
            <CloseBold />
          </button>
        </div>
      </>
    );
  }

  if (fileType === 'pdf' || isConvertedFile) {
    return (
      <ErrorBoundary onError={() => null} logLevel={logLevelWarning}>
        <TransformWrapper
          wheel={{ disabled: isDesktop }}
          doubleClick={{ disabled: true }}
          pinch={{ disabled: isDesktop }}
          panning={{ disabled: isDesktop }}
          disablePadding
        >
          <TransformComponent
            wrapperClass={classes.wrapperClass}
            wrapperStyle={{ overflow: isDesktop ? 'auto' : 'visible' }}
          >
            <div
              className={clsx(
                className,
                classes.container,
                !isDesktop && 'mobile',
                'document-preview'
              )}
            >
              <div ref={containerRef}>
                <PdfViewerBase
                  className={classes.pdfViewer}
                  containerRef={containerRef}
                  file={filePath}
                  width={isDesktop ? 600 : 360}
                  useInfiniteScroll
                  scale={isDesktop ? zoomLevels[zoomLevelIndex] : 1}
                />
              </div>
            </div>
          </TransformComponent>
        </TransformWrapper>
        <div
          className={clsx(
            className,
            classes.previewZoomButtons,
            !isDesktop && 'mobile'
          )}
        >
          <button
            type="button"
            aria-label="zoom out"
            onClick={() => onDocumentClose()}
          >
            <CloseBold />
          </button>
          {isDesktop && (
            <>
              <button
                type="button"
                aria-label="zoom in"
                onClick={() => onZoomIn()}
                style={{ marginTop: '20px' }}
              >
                <Plus />
              </button>
              <button
                type="button"
                aria-label="zoom out"
                onClick={() => onZoomOut()}
              >
                <Minus />
              </button>
            </>
          )}
        </div>
      </ErrorBoundary>
    );
  }
  return (
    <ShowErrorMessage
      documentOriginalPath={filePath}
      onClose={() => onDocumentClose()}
    />
  );
};

export default withStyles(styles)(FileViewer);
